import ActionTypes from '../../constants/ActionTypes'

const initialState = {
  shouldCallLogin: false,
}

export default function (state = initialState, action) {
  switch (action.type) {
    case ActionTypes.SESSION_DATA.SHOULD_CALL_LOGIN :
      return {
        shouldCallLogin: action.payload
      };
    default:
      return state;
  }
}
